<script>
  import { fade } from "svelte/transition";
  export let notification;
  export let onRemove = null;
  let color = "#dc3545";
  const danger = "#dc3545";
  const success = "#28a745";
  const info = "#17a2b8";
  const warning = "#ffc107";

  $: if (notification) {
    switch (notification.type) {
      case "danger":
        color = danger;
        break;
      case "success":
        color = success;
        break;
      case "info":
        color = info;
        break;
      case "warning":
        color = warning;
        break;
      default:
        color = danger;
        break;
    }
  }
</script>

<style>
  .notification {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    margin-bottom: 15px;
    margin-right: 10px;
    color: white;
    border-radius: 0px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  }
  .notification-content {
    width: 400px;
    padding: 12px 6px 12px 12px;
    box-sizing: border-box;
    word-wrap: break-word;
  }
  .notification-content p {
    font-size: 14px;
    color: white;
    margin: 2px 0 0;
  }

  button {
    display: block;
    width: 60px;
    height: 50%;
    padding: 0 0 2px;
    margin: 0;
    border: none;
    outline: none;
    background: none;
    cursor: pointer;
    font-size: 12px;
    color: #666;
    box-sizing: border-box;
  }
  button:hover {
    background: rgba(0, 0, 0, 0.01);
  }
</style>

<div class="notification" style={`background:${color}`} in:fade out:fade>
  <div class="notification-content">
    <slot>{notification.text}</slot>
    <p>{notification.description || 'Custom description'}</p>
  </div>
  <div>
    <button on:click={onRemove}>
      <i class="fa fa-times" />
    </button>
  </div>
</div>
